// feature-flag.directive.ts
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagService } from '../../services/helpers/feature-flag.service';

@Directive({
  selector: '[ngFlag]',
})
export class FeatureFlagDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private flagService: FeatureFlagService
  ) {}

  @Input() set ngFlag(featureName: string) {
    const isEnabled = this.flagService.isFeatureEnabled(featureName);

    if (isEnabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isEnabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
